import React, { useState } from 'react';
import { Modal } from '../ui/Modal';
import { Button } from '../ui/Button';
import { Input } from '../ui/Input';
import { ShieldCheck, AlertCircle } from 'lucide-react';
interface SignInModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSignIn: (email: string, password: string) => Promise<boolean>;
}
export function SignInModal({
  isOpen,
  onClose,
  onSignIn
}: SignInModalProps) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);
    try {
      const success = await onSignIn(email, password);
      if (success) {
        onClose();
        setEmail('');
        setPassword('');
      } else {
        setError('Invalid credentials. Try demo@provenanceone.ai / password');
      }
    } catch (err) {
      setError('Authentication failed. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };
  return <Modal isOpen={isOpen} onClose={onClose} size="sm" data-id="element-119">
      <div className="space-y-6" data-id="element-120">
        {/* Header */}
        <div className="flex items-center space-x-3" data-id="element-121">
          <div className="flex-shrink-0 h-12 w-12 bg-teal-500/10 rounded-lg flex items-center justify-center border border-teal-500/20" data-id="element-122">
            <ShieldCheck className="h-6 w-6 text-teal-500" data-id="element-123" />
          </div>
          <div data-id="element-124">
            <h3 className="text-xl font-semibold text-white" data-id="element-125">Sign In</h3>
            <p className="text-sm text-slate-400" data-id="element-126">
              Access your assessment library
            </p>
          </div>
        </div>

        {/* Demo Credentials Notice */}
        <div className="bg-navy-900 border border-slate-700 rounded-lg p-4" data-id="element-127">
          <p className="text-sm text-slate-400 mb-2" data-id="element-128">
            <span className="font-semibold text-slate-300" data-id="element-129">
              Demo Credentials:
            </span>
          </p>
          <div className="font-mono text-xs text-teal-400 space-y-1" data-id="element-130">
            <div data-id="element-131">Email: demo@provenanceone.ai</div>
            <div data-id="element-132">Password: password</div>
          </div>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit} className="space-y-4" data-id="element-133">
          <Input label="Email" type="email" placeholder="email@example.com" value={email} onChange={e => setEmail(e.target.value)} required autoComplete="email" data-id="element-134" />

          <Input label="Password" type="password" placeholder="Enter password" value={password} onChange={e => setPassword(e.target.value)} required autoComplete="current-password" data-id="element-135" />

          {error && <div className="flex items-start space-x-2 p-3 bg-red-500/10 border border-red-500/20 rounded-lg" data-id="element-136">
              <AlertCircle className="h-4 w-4 text-red-400 mt-0.5 flex-shrink-0" data-id="element-137" />
              <p className="text-sm text-red-400" data-id="element-138">{error}</p>
            </div>}

          <div className="flex items-center justify-end space-x-3 pt-4 border-t border-slate-700" data-id="element-139">
            <Button type="button" variant="ghost" onClick={onClose} data-id="element-140">
              Cancel
            </Button>
            <Button type="submit" isLoading={isLoading} className="min-w-[120px]" data-id="element-141">
              Sign In
            </Button>
          </div>
        </form>
      </div>
    </Modal>;
}